// -----天猫系
import axios from './axios.js'
import qs from 'qs'

//登陆获取token
export const login = params => {
  return axios.get(`/login`, { params })
};
//退出
export const logout = params => {
  return axios.get(`/user/sysLogout`, { params })
};
//获取菜单
export const getMenuList = params => {

  return axios.get(`/menu/getMenuTree`, { params, hideLoading: true })
};
//获取店铺
export const getShopList = params => {
  return axios.get(`/shop/getUserShops`, { params })
};
// export const getShopList = params => {
//     return axios.get(`/shop`, {params})
// };

// 查询当前用户是否为MA系统管理员
export const checkUserIsAdmin = params => {
  return axios.get(`/user/checkUserIsAdmin`, { params })
};



// 用户拥有的平台列表
export const getUserPlatList = params => {
  return axios.get(`/user/getUserPlatList`, { params })
};

//获取用户信息

export const userInfo = params => {
  return axios.get(`/user/userInfo`, { params })
};
/* 直通车 start */
/**
 * 智能监控 目前属于总览下
 */
//花费预警列表
export const findByPage = params => {
  return axios.post(`/warning/findScheduleByPage`, params)
};
//添加预警任务
export const addSchedule = params => {
  return axios.post(`/warning/createSchedule`, params)
};
//删除预警任务
export const delSchedule = params => {
  return axios.get(`/warning/deleteScheduleJob`, { params })
};
//获取渠道信息
export const getCostWaringTypeInfo = params => {
  return axios.get(`/goodsCost/getCostWaringTypeInfo`, { params })
};
//根据渠道获取计划信息
export const getCampaignsInfo = params => {
  return axios.get(`/goodsCost/getCampaignsInfo`, { params })
};
//根据店铺获取推广计划信息
export const getCampaigns = params => {
  return axios.get(`/warning/getCampaignsInfoBySellerId`, { params })
};
//根据店铺获取该店铺下用户信息
export const getUserInfoBySellerId = params => {
  return axios.get(`/warning/getUserInfoBySellerId`, { params })
};
//获取触发效果信息
export const getTriggerResultInfo = params => {
  return axios.post(`/goodsStock/getTriggerResultInfo`, params)
};
//根据id获取定时任务信息
export const findByRecordId = params => {
  return axios.get(`/warning/findByRecordId`, { params })
};
//获取库存预警任务日志列表
export const getGoodsStockWarnPage = params => {
  return axios.post(`/goodsStock/getGoodsStockWarnPage`, params)
};
//分页获取任务下的推广单元信息
export const getAdGroupInfoByJobId = params => {
  return axios.post(`/goodsStock/getAdGroupInfoByJobId`, params)
};
//暂停或开启推广单元
export const closeAndOpenAdGroup = params => {
  return axios.get(`/goodsStock/closeAndOpenAdGroup`, { params, hideLoading: true })
};
//获取商品库存报表
export const getOnlineGoodsStockInfo = params => {
  return axios.post(`/goodsStock/getOnlineGoodsStockInfo`, params)
};
//导出商品库存报表
export const exportOnlineGoodsStockInfo = params => {
  return axios.post(`/goodsStock/exportOnlineGoodsStockInfo`, params, { responseType: "blob" })
};

/*
* 营销效果分析
* */
//获取关键词报表信息
export const findKeywordReportInfo = params => {
  return axios.post(`/keywordReport/findKeywordReportInfo`, params)
};
//获取关键词报表历史数据列表信息接口
export const keywordHisReportInfo = params => {
  return axios.post(`/keywordReport/keywordHisReportInfo`, params)
};
//获取关键词表现信息
export const findKeywordPerformInfo = params => {
  return axios.post(`/keywordReport/findKeywordPerformInfo`, params)
};
export const keywordHisReportDetailInfo = params => {
  return axios.post(`/keywordReport/keywordHisReportDetailInfo`, params)
};
//导出关键词报表
export const exportKeywordReport = params => {
  return axios.post(`/keywordReport/exportKeywordReport`, params, { responseType: "blob" })
};
export const exportKeywordHisReportInfo = params => {
  return axios.post(`/keywordReport/exportKeywordHisReportInfo`, params, { responseType: "blob" })
};
//导出关键词表现
export const exportKeywordPerform = params => {
  return axios.post(`/keywordReport/exportKeywordPerform`, params, { responseType: "blob" })
};
export const exportKeywordHisReportDetailInfo = params => {
  return axios.post(`/keywordReport/exportKeywordHisReportDetailInfo`, params, { responseType: "blob" })
};
//修改历史关键词出价
export const updateHisKeywordPrice = params => {
  return axios.post(`/keywordReport/updateHisKeywordPrice`, params)
};

//人群表现报表-人群报表-超级推荐
export const queryRecommendCrowdReport = params => {
  return axios.post(`/overview/queryRecommendCrowdReport`, params)
};
//计划表现报表-计划报表-超级推荐
export const queryRecommendCampaignReport = params => {
  return axios.post(`/overview/queryRecommendCampaignReport`, params)
};
//人群表现报表-创意报表-超级推荐
export const queryRecommendGroupReport = params => {
  return axios.post(`/overview/queryRecommendGroupReport`, params)
};
//人群表现报表-人群报表-超级推荐下载
export const downloadRecommendCrowdReport = params => {
  return axios.post(`/overview/downloadRecommendCrowdReport`, params, { responseType: "blob" })
};
//人群表现报表-资源位报表-超级推荐下载
export const downloadRecommendAdzoneReport = params => {
  return axios.post(`/overview/downloadRecommendAdzoneReport`, params, { responseType: "blob" })
};
//计划报表-超级推荐下载
export const downloadRecommendCampaignReport = params => {
  return axios.post(`/overview/downloadRecommendCampaignReport`, params, { responseType: "blob" })
};
//创意报表-超级推荐下载
export const downloadRecommendGroupReport = params => {
  return axios.post(`/overview/downloadRecommendGroupReport`, params, { responseType: "blob" })
};
//-创意报表-超级推荐下载
export const downloadRecommendCreativeReport = params => {
  return axios.post(`/overview/downloadRecommendCreativeReport`, params, { responseType: "blob" })
};

//人群表现报表-创意报表-钻展导出
export const downloadDiamondCreativeReport = params => {
  return axios.post(`/overview/downloadDiamondCreativeReport`, params, { responseType: "blob" })
};
// 查询超推人群报表计划下拉列表
export const queryRecGroupCampaignList = params => {
  return axios.post(`/overview/queryRecGroupCampaignList`, params)
};

// 查询-创意-超推人群报表计划下拉列表
export const queryRecCrowdCampaignList = params => {
  return axios.post(`/overview/queryRecCrowdCampaignList`, params)
};
// 查询-资源位-超推人群报表计划下拉列表
export const queryRecAdzoneCampaignList = params => {
  return axios.post(`/overview/queryRecAdzoneCampaignList`, params)
};


// 查询-资源位-超推人群报表计划下拉列表
export const queryRecommendAdzoneReport = params => {
  return axios.post(`/overview/queryRecommendAdzoneReport`, params)
};
// 查询-计划-超推人群报表计划下拉列表
export const queryRecCampaignCampaignList = params => {
  return axios.post(`/overview/queryRecCampaignCampaignList`, params)
};
// 查询超推人群报表推广单元下拉列表
export const queryRecCrowdAdgroupList = params => {
  return axios.post(`/overview/queryRecCrowdAdgroupList`, params)
};
// 查询超推资源位报表推广单元下拉列表
export const queryRecAdzoneAdgroupList = params => {
  return axios.post(`/overview/queryRecAdzoneAdgroupList`, params)
};
// 查询超推资源位资源下拉列表
export const queryRecAdzoneAdzoneList = params => {
  return axios.post(`/overview/queryRecAdzoneAdzoneList`, params)
};
// 查询-创意-超推人群报表推广单元下拉列表
export const queryRecGroupAdgroupList = params => {
  return axios.post(`/overview/queryRecGroupAdgroupList`, params)
};
// 查询超推创意报表推广单元下拉列表
export const queryRecCreAdgroupList = params => {
  return axios.post(`/overview/queryRecCreAdgroupList`, params)
};
// 查询超推创意报表推广单元下拉列表
export const queryRecCreCreativeList = params => {
  return axios.post(`/overview/queryRecCreCreativeList`, params)
};
//查询超推创意报表计划下拉列表
export const queryRecCreCampaignList = params => {
  return axios.post(`/overview/queryRecCreCampaignList`, params)
};
// 超级推荐部分-创意报表
export const queryRecommendCreativeReport = params => {
  return axios.post(`/overview/queryRecommendCreativeReport`, params)
};


// 获取钻展人群报表计划组数据
export const queryDiaCrowdCamGroupList = params => {
  return axios.post(`/overview/queryDiaCrowdCamGroupList`, params)
};
// 获取钻展资源位报表计划组数据
export const queryDiaAdzoneCamGroupList = params => {
  return axios.post(`/overview/queryDiaAdzoneCamGroupList`, params)
};
// 获取计划人群报表计划组数据
export const queryDiaCamCamGroupList = params => {
  return axios.post(`/overview/queryDiaCamCamGroupList`, params)
};
// 获取钻展人群报表计划数据
export const queryDiaCrowdCampaignList = params => {
  return axios.post(`/overview/queryDiaCrowdCampaignList`, params)
};
// 获取钻展资源位报表计划数据
export const queryDiaAdzoneCampaignList = params => {
  return axios.post(`/overview/queryDiaAdzoneCampaignList`, params)
};
// 获取钻展计划报表计划数据
export const queryDiaCamCampaignList = params => {
  return axios.post(`/overview/queryDiaCamCampaignList`, params)
};
// 查询直通车人群报表数据推广组列表
export const querySubCrowdAdgroupList = params => {
  return axios.get(`/keywordReport/querySubCrowdAdgroupList`, { params })
};
// 查询直通车人群报表数据计划列表
export const querySubCrowdCampaignList = params => {
  return axios.get(`/keywordReport/querySubCrowdCampaignList`, { params })
};
// 查询直钻超总览店铺关注指标维度
export const queryOverviewIndexDimension = params => {
  return axios.get(`/overview/queryOverviewIndexDimension`, { params })
};
// 更新直钻超总览店铺关注指标维度
export const updateOverviewIndexDimension = params => {
  return axios.get(`/overview/updateOverviewIndexDimension`, { params })
};
// 查询渠道总览的历史数据
export const queryChannelHistoryData = params => {
  return axios.get(`/overview/queryChannelHistoryData`, { params })
};
// 通过店名id获取直通车、引力魔方过期时间
export const queryDeadDateBySellerId = params => {
  return axios.get(`/overview/QueryDeadDateBySellerId`, { params })
};

// 查询直通车计划报表数据计划列表
export const queryPromotionName = params => {
  return axios.get(`/overview/queryPromotionName`, { params })
};

// 获取钻展表格数据
export const queryDiamondCrowdReport = params => {
  return axios.post(`/overview/queryDiamondCrowdReport`, params)
};
// 获取-资源位-钻展表格数据
export const queryDiamondAdzoneReport = params => {
  return axios.post(`/overview/queryDiamondAdzoneReport`, params)
};
// 获取-计划-钻展表格数据
export const queryDiamondCampaignReport = params => {
  return axios.post(`/overview/queryDiamondCampaignReport`, params)
};
// 人群表报-钻展
export const downloadDiamondCrowdReport = params => {
  return axios.post(`/overview/downloadDiamondCrowdReport`, params, { responseType: "blob" })
};
// 资源位-钻展
export const downloadDiamondAdzoneReport = params => {
  return axios.post(`/overview/downloadDiamondAdzoneReport`, params, { responseType: "blob" })
};
// 计划表报-钻展
export const downloadDiamondCampaignReport = params => {
  return axios.post(`/overview/downloadDiamondCampaignReport`, params, { responseType: "blob" })
};
// 创意表报-鉆展-查询接口
export const queryDiamondCreativeReport = params => {
  return axios.post(`/overview/queryDiamondCreativeReport`, params)
};

// 创意报表-鉆展-创意
export const queryDiaCreCreativeList = params => {
  return axios.post(`/overview/queryDiaCreCreativeList`, params)
};
// 创意报表-鉆展-获取钻展创意报表计划组数据
export const queryDiaCreCamGroupList = params => {
  return axios.post(`/overview/queryDiaCreCamGroupList`, params)
};
// 创意报表-鉆展-获取钻展创意报表计划数据
export const queryDiaCreCampaignList = params => {
  return axios.post(`/overview/queryDiaCreCampaignList`, params)
};
// 创意报表-鉆展-获取钻展创意报表计划数据
export const queryDiaCrowdCrowdList = params => {
  return axios.post(`/overview/queryDiaCrowdCrowdList`, params)
};
// 资源位-鉆展-获取钻展资源位数据
export const queryDiaAdzoneAdzoneList = params => {
  return axios.post(`/overview/queryDiaAdzoneAdzoneList`, params)
};
//删除历史关键词
export const deleteHisKeyword = params => {
  return axios.post(`/keywordReport/deleteHisKeyword`, params)
};
/*
* 自动投放
* */
//计划列表
export const getCampaignInfo = params => {
  return axios.get(`/putKeyWord/findCampaignInfo`, { params })
};
//商品列表
export const getGoodsInfo = params => {
  return axios.post(`/putKeyWord/findGoodsInfo`, params)
};
//实时获取出售中的商品信息
export const findOnsaleGoods = params => {
  return axios.post(`/putKeyWord/findOnsaleGoods`, params)
};
//根据商品信息创建推广单元
export const createAdGroupByGoodsInfo = params => {
  return axios.post(`/putKeyWord/createAdGroupByGoodsInfo`, params, { hideLoading: true })
};
//创建计划
export const createSubwayCampaign = params => {
  return axios.get(`/putKeyWord/createSubwayCampaign`, { params })
};
//重新创建推广单元
export const findCreateAdGroupLog = params => {
  return axios.get(`/putKeyWord/createAdGroupByGoodsInfoAgain`, { params })
};
//关键词去重
export const removeDuplicateKeyword = params => {
  return axios.post(`/addKeyWord/removeDuplicateKeyword`, params)
};
//查询推广单元创建日志信息
export const findAdGroupCreateLogInfo = params => {
  return axios.post(`/putKeyWord/findAdGroupCreateLogInfo`, params)
};
//查询创建成功的推广单元信息
export const findCreatedGroupInfo = params => {
  return axios.get(`/putKeyWord/findCreatedGroupInfo`, { params })
};
//类目列表
export const getItemsInfo = params => {
  return axios.get(`/putKeyWord/getItemsInfo`, { params })
};
//根据状态查询钻展计划列表
export const queryDiamondCampaignByStatus = params => {
  return axios.get(`/diamond/queryDiamondCampaignByStatus`, { params })
};
// 创建钻展筛选创意任务
export const createDiamondFilterCreative = params => {
  return axios.post(`/diamond/createDiamondFilterCreative`, params)
};
//获取钻展筛选创意任务列表
export const queryDiamondFilterCreativeJob = params => {
  return axios.get(`/diamond/queryDiamondFilterCreativeJob`, { params })
};
//获取钻展筛选创意日志信息
export const queryDiamondFilterCreativeLog = params => {
  return axios.get(`/diamond/queryDiamondFilterCreativeLog`, { params })
};
//删除定时任务
export const deleteScheduleJob = params => {
  return axios.get(`/warning/deleteScheduleJob`, { params })
};

// 批量上传创意

export const batchUploadDiamondCreative = params => {
  return axios.post(`/diamond/batchUploadDiamondCreative`, params, { headers: { 'Content-Type': 'multipart/form-data' } })
};

// 查询地址
export const getMaShopMobileHomePage = params => {
  return axios.get(`/diamond/getMaShopMobileHomePage`, { params })
};
export const queryDiamondCreativeStatus = params => {
  return axios.get(`/diamond/queryDiamondCreativeStatus`, { params })
};
//关键词列表
export const getKeywordInfo = params => {
  return axios.post(`/putKeyWord/findKeywordInfo`, params)
};
//生成组合列表
export const getGoodsAndKeyword = params => {
  return axios.post(`/putKeyWord/linkGoodsAndKeyword`, params)
};
//删除组合列表
export const deleteGoodsAndKeyword = params => {
  return axios.get(`/putKeyWord/deleteLinkGoodsAndKeyword`, { params })
};
//分页组合列表
export const getFindGoodsKeyword = params => {
  return axios.post(`/putKeyWord/findGoodsKeywordLinkByPage`, params)
};
//创建组合
export const createPutKeywords = params => {
  return axios.post(`/putKeyWord/createPutKeywords`, params, { hideLoading: true })
};
//获取投放关键词实时进度
export const getProcessing = params => {
  return axios.get(`/putKeyWord/getProcessing`, { params, hideLoading: true })
};

//获取生意参谋关键词信息
export const getSycmKeywordList = params => {
  return axios.post(`/addKeyWord/findSycmKeywordsInfo`, params)
};
//获取生意参谋类目信息
export const getSycmItemsList = params => {
  return axios.get(`/addKeyWord/findSycmItemsInfo`, { params, hideLoading: true })
};

//获取行业热词列表
export const getFindHotList = params => {
  return axios.post(`/addKeyWord/findHotKeywordsInfo`, params)
};
//获取搜索词列表
export const getFindSearchList = params => {
  return axios.post(`/addKeyWord/findSearchKeywordsInfo`, params)
};
//获取推广单元接口
export const getFindAdGroupInfo = params => {
  return axios.get(`/addKeyWord/findAdGroupInfo`, { params, hideLoading: true })
};
//添加关键词到单元
export const createKeywords = params => {
  return axios.post(`/addKeyWord/createKeywordsToAdGroup`, params)
};
//创建状态列表
export const getAdgroupKeyword = params => {
  return axios.get(`/addKeyWord/getAdgroupKeywordLinkPage`, { params, hideLoading: true })
};
//查看日志列表
export const getAdgroupKeywordLog = params => {
  return axios.post(`/addKeyWord/getAdgroupKeywordLinkPage`, (params))
};
//查看日志的计划列表
export const searchChangeKeywordCampaignList = params => {
  return axios.get(`/changeKeyWord/searchChangeKeywordCampaignList`, { params })
};
//查看日志的单元列表
export const searchChangeKeywordGroupList = params => {
  return axios.get(`/changeKeyWord/searchChangeKeywordGroupList`, { params })
};
//失败重新创建
export const createKeywordsAjain = params => {
  return axios.post(`/addKeyWord/createKeywordsToAdGroupAgain`, (params))
};
//导出报表1
export const exportAdgroup = params => {
  return axios.post(`/addKeyWord/createSycmKeywordFile`, (params))
};
//导出报表2
export const getAdgroupKeywordLink = params => {
  return axios.get(`/addKeyWord/export`, { params })
};
//日志信息创建人列表
export const getLogCreateNameList = params => {
  return axios.get(`/addKeyWord/getLogCreateNameList`, { params })
};
//查询指定计划下的单元列表
export const findAdGroupInfo = params => {
  return axios.get(`/addKeyWord/findAdGroupInfo`, { params })
};
//根据计划Id和推广组Id集合批量获取推广组信息
export const queryGroupInfoByCampaignId = params => {
  return axios.post(`/changeKeyWord/queryGroupInfoByCampaignId`, (params))
};
// 查询关键词列表
export const querySubwayQuickChangePriceKeywordInfos = params => {
  return axios.post(`/changeKeyWord/querySubwayQuickChangePriceKeywordInfos`, params)
};
//获取推广单元信息
export const getAdGroupInfo = params => {
  return axios.post(`/changeKeyWord/getAdGroupInfoByCampaignId`, (params))
};
//获取关键词信息
export const getChangeKeywordInfo = params => {
  return axios.post(`/changeKeyWord/getKeywordInfo`, (params))
};
//修改关键词出价
export const updateKeywordPrice = params => {
  return axios.post(`/changeKeyWord/updateKeywordPrice`, (params))
};
// 根据单元批量修改关键词价格
export const updateKeywordPriceByGroup = params => {
  return axios.post(`/changeKeyWord/updateKeywordPriceByGroup`, (params))
};


//快捷改价日志用于判断最早可选日期
export const searchChangeKeywordLogMinDate = params => {
  return axios.get(`/changeKeyWord/searchChangeKeywordLogMinDate`, { params })
};
//快捷改价日志创建人列表
export const searchChangeKeywordLogCreateInfo = params => {
  return axios.get(`/changeKeyWord/searchChangeKeywordLogCreateInfo`, { params })
};
//快捷改价日志信息
export const searchChangeKeywordLogInfo = params => {
  return axios.post(`/changeKeyWord/searchChangeKeywordLogInfo`, (params))
};
//获取指标信息
export const getTargetInfo = params => {
  return axios.post(`/changeKeyWord/getTargetInfo`, (params))
};
// 获取日志信息
export const getLogInfo = params => {
  return axios.get(`/logInfo/getLogInfo`, { params })
};

// 获取引力魔方日志信息
export const getCubeLogInfo = params => {
  return axios.post(`/logInfo/getCubeLogInfo`, (params))
};

//获取查询条件
export const getConditionInfo = params => {
  return axios.post(`/changeKeyWord/getConditionInfo`, (params))
};
// 根据商品Id列表批量查询商品匹配状态
export const queryGoodsStatusByNumIids = params => {
  return axios.post(`/overview/queryGoodsStatusByNumIids`, (params))
};
// 查询商品状态信息
export const queryMerchandiseStatusInfos = params => {
  return axios.post(`/overview/queryMerchandiseStatusInfos`, (params))
}
// 查询商品状态信息
export const updateMerchandiseStatus = params => {
  return axios.post(`/overview/updateMerchandiseStatus`, (params))
}

//批量删除关键词
export const deleteKeywordById = params => {
  return axios.post(`/changeKeyWord/deleteKeywordById`, (params))
};


/* 直通车 end */

/* 系统设置 start */
/**
 * 菜单管理
 */
//获取所有菜单树
export const getAllMenus = params => {
  return axios.get(`/menu/getMenus`, { params })
};
//查询详细菜单
export const getMenusInfo = params => {
  return axios.get(`/menu/getMenuById`, { params })
};
//更新菜单
export const updateMenu = params => {
  return axios.post(`/menu/updateMenu`, qs.parse(params))
};
//添加菜单
export const addMenu = params => {
  return axios.post(`/menu/saveMenu`, qs.parse(params), { hideLoading: true })
};
//删除菜单
export const delMenu = params => {
  return axios.post(`/menu/deleteById`, qs.parse(params), { hideLoading: true })
};

/**
 * 角色管理
 */
//获取角色列表
export const getRoleList = params => {
  return axios.get(`/role/getRoleList`, { params, hideLoading: true })
};
// export const getRoleList = params => {
//     return axios.get(`/role`, {params,hideLoading: true})
// };
/*//新增角色
export const addRole = params => {
  return axios.post(`/role`,qs.parse(params),{hideLoading: true})
};*/
//编辑角色
export const updateRole = params => {
  return axios.post(`/role/saveOrUpdateRole`, qs.parse(params), { hideLoading: true })
};
//保存角色
export const updateRoleMenu = params => {
  return axios.post(`/role/saveOrUpdateRoleMenu`, qs.parse(params), { hideLoading: true })
};
//删除角色
export const deleteById = params => {
  return axios.post(`/role/deleteById`, qs.parse(params), { hideLoading: true })
};
//根据角色获取菜单
export const findRoleMenus = params => {
  return axios.get(`/role/findRoleMenus`, { params })
};

/**
 * 用户管理
 */
//获取所有用户列表
export const getUserList = params => {
  return axios.get(`/user/getUserList`, { params, hideLoading: true })
};
//根据用户获取店铺
export const findUserShops = params => {
  return axios.get(`/user/findUserShops`, { params })
};
//获取所有店铺
export const getAllShopList = params => {
  return axios.get(`/shop/getShopList`, { params, hideLoading: true })
};
//保存用户设置
export const updateShopRole = params => {
  return axios.post(`/user/updateShopRole`, qs.parse(params), { hideLoading: true })
};
/* 系统设置 end */


//直通车总览
//看板数据
export const getRealAndForecastDatas = params => {
  return axios.get(`/overview/getRealAndForecastDatas`, { params })
};
//分时数据
export const querySubwayDatasByHour = params => {
  return axios.get(`/overview/queryDatasByHour`, { params, hideLoading: true })
};
//分天数据
export const querySubwayDatasByDay = params => {
  return axios.get(`/overview/queryDatasByDay`, { params, hideLoading: true })
};
//今日计划列表
export const queryTodayCampaignInfos = params => {
  return axios.get(`/overview/queryTodayCampaignInfos`, { params, hideLoading: true })
};
//推广单元列表
export const queryGroupInfosByPage = params => {
  return axios.get(`/overview/queryGroupInfosByPage`, { params, hideLoading: true })
};
//查找店铺当前的计划列表
export const queryCompaignsLists = params => {
  return axios.get(`/overview/queryCampaignsLists`, { params, hideLoading: true })
};
//根据推广计划查询推广单元
export const queryGroupsByCampaigns = params => {
  return axios.get(`/overview/queryGroupsByCampaigns`, { params })
};
//添加推广单元到关注列表
export const addGroupToAttentionLists = params => {
  return axios.post(`/overview/addGroupToAttentionLists`, qs.parse(params))
};
//取消关注的推广单元
export const deleteAttentionGroup = params => {
  return axios.get(`/overview/deleteAttentionGroup`, { params })
};
//根据日期查看添加日志
export const queryAddLogByDate = params => {
  return axios.get(`/overview/queryAddLogByDate`, { params })
};
//查询总览信息
export const getQueryOverviewPlanInfos = params => {
  return axios.get(`/overview/queryOverviewPlanInfos`, { params })
};
//编辑总览信息
export const bathUpdateOverviewPlanInfos = params => {
  return axios.post(`/overview/bathUpdateOverviewPlanInfos`, qs.parse(params))
};
//下载总览信息模板
export const downloadOverviewPlanModel = params => {
  return axios.get(`/overview/downloadOverviewPlanModel`, { params, responseType: "blob" })
};
//批量导入总览信息
export const uploadOverviewPlanInfos = params => {
  return axios.post(`overview/uploadOverviewPlanInfos`, params, { headers: { 'Content-Type': 'multipart/form-data' } })
};
//渠道总览 看板数据表格
export const queryOverviewReportInfos = params => {
  return axios.get(`/overview/queryOverviewReportInfos`, { params })
};
//渠道总览 实时数据
export const getOverviewRealAndForecastDatas = params => {
  return axios.get(`/overview/getOverviewRealAndForecastDatas`, { params })
};
//多渠道分天数据
export const queryOverviewChannelDatasByDay = params => {
  return axios.get(`/overview/queryOverviewChannelDatasByDay`, { params })
};
//下载总览报表
export const downloadOverviewReportInfos = params => {
  return axios.get(`/overview/downloadOverviewReportInfos`, { params, responseType: "blob" })
};
//多渠道分天数据
export const queryOverviewAllIndexDimension = params => {
  return axios.get(`/overview/queryOverviewAllIndexDimension`, { params })
};

//页面数据埋点
export const addOverviewSystemLoginLogs = params => {
  return axios.post(`overview/addOverviewSystemLoginLogs`, params, { hideLoading: true })
};

//查询页面浏览
export const querySystemLoginLogs = params => {
  return axios.get(`overview/querySystemLoginLogs`, { params })
};
// 查询推广组对应的商品已绑定的创意
export const queryCreativeBindByGroupId = params => {
  return axios.get(`overview/queryCreativeBindByGroupId`, { params })
};

// 批量上传超级推荐创意
export const batchUploadRecommendCreative = params => {
  return axios.post(`overview/batchUploadRecommendCreative`, params)
};
// 删除推广组对应的商品已绑定的创意
export const unbindCreativeByCreativeId = params => {
  return axios.get(`overview/unbindCreativeByCreativeId`, { params })
};



//获取埋点页面
export const querySystemMenuLists = params => {
  return axios.get(`overview/querySystemMenuLists`, { params })
};
//获取部门列表
export const queryLoginDepartments = params => {
  return axios.get(`overview/queryLoginDepartments`, { params })
};
//查询具体页面的浏览量
export const querySystemMenuLoginLogs = params => {
  return axios.get(`overview/querySystemMenuLoginLogs`, { params })
};
//超级推荐 快捷上品 计划列表
export const queryCampaignLists = params => {
  return axios.get(`recommendMerchandise/queryCampaignLists`, { params })
};
// 查询店铺的商品
export const queryItemByPage = params => {
  return axios.get(`recommendMerchandise/queryItemByPage`, { params })
};
// 查询定向人数
export const queryOptionCrowdLists = params => {
  return axios.get(`recommendMerchandise/queryOptionCrowdLists`, { params })
};
// 达摩盘人群列表
export const queryBannerDmpFindLists = params => {
  return axios.get(`recommendMerchandise/queryBannerDmpFindLists`, { params })
};
// 查询资源位列表
export const queryAdzoneLists = params => {
  return axios.get(`recommendMerchandise/queryAdzoneLists`, { params })
};
// 创建资源位
export const queryGroupAdzoneLists = params => {
  return axios.post(`recommendMerchandise/addItemGroup`, params)
};

//根据numIid查询推广计划详情
export const queryGroupsInfosByNumIid = params => {
  return axios.get(`overview/queryGroupsInfosByNumIid`, { params })
};
//获取总览余额数据
export const queryOverviewAccount = params => {
  return axios.get(`overview/queryOverviewAccount`, { params })
};

//总览-标签管理
//查询关键词标签
export const searchKeywordTag = params => {
  return axios.post(`/tagKeyword/searchKeywordTag`, params)
};
//新增和修改关键词标签
export const createOrUpdateKeywordTag = params => {
  return axios.post(`/tagKeyword/createOrUpdateKeywordTag`, params)
};
//关键词添加标签
export const bindTagToKeyword = params => {
  return axios.post(`/tagKeyword/bindTagToKeyword`, params)
};
//关键词报表信息
export const searchKeywordRtptInfo = params => {
  return axios.post(`/tagKeyword/searchKeywordRtptInfo`, params)
};
//根据标签ID获取关键词列表
export const getKeywordTagListByTagId = params => {
  return axios.post(`/tagKeyword/getKeywordTagListByTagId`, params)
};
//删除关键词标签
export const deleteKeywordTag = params => {
  return axios.get(`/tagKeyword/deleteKeywordTag`, { params })
};
//关键词解绑标签
export const unBindKeywordTag = params => {
  return axios.get(`/tagKeyword/unBindKeywordTag`, { params })
};
//获取所有推广单元信息
export const getAllAdGroupInfoByCampaignId = params => {
  return axios.get(`/tagKeyword/getAllAdGroupInfoByCampaignId`, { params, hideLoading: true })
};
//获取所有计划信息
export const getAllCampaignInfo = params => {
  return axios.get(`/tagKeyword/getAllCampaignInfo`, { params })
};
//获取所有关键词标签名称信息
export const getKeywordTagName = params => {
  return axios.get(`/tagKeyword/getKeywordTagName`, { params })
};
//获取指定关键词下未绑定的标签信息
export const getNotBindTagInfoByKeyword = params => {
  return axios.get(`/tagKeyword/getNotBindTagInfoByKeyword`, { params })
};
//查询单个关键词标签
export const getKeywordTagInfoById = params => {
  return axios.get(`/tagKeyword/getKeywordTagInfoById`, { params })
};
//标签绑定关键词
export const bindKeywordToTag = params => {
  return axios.post(`/tagKeyword/bindKeywordToTag`, params)
};
//导入关键词 过滤已被绑定的关键词
export const filterBoundKeyword = params => {
  return axios.post(`/tagKeyword/filterBoundKeyword`, params)
};

//直通车历史看板指标初始化
export const defaultSubwayIndexDimension = params => {
  return axios.get(`/overview/defaultSubwayIndexDimension`, { params })
};
//获取直通车全部指标数据
export const querySubwayIndexDimension = params => {
  return axios.get(`/overview/querySubwayIndexDimension`, { params })
};
//获取-直通车计划数据
export const querySubGroupCampaignList = params => {
  return axios.get(`/overview/querySubGroupCampaignList`, { params })
};
//推广单元-直通车-单元
export const querySubGroupAdgroupList = params => {
  return axios.get(`/overview/querySubGroupAdgroupList`, { params })
};
//推广单元-直通车-下载
export const downloadSubwayGroupReport = params => {
  return axios.get(`/overview/downloadSubwayGroupReport`, { params, responseType: "blob" })
};
//推广单元-直通车-数据
export const querySubwayGroupReport = params => {
  return axios.get(`/overview/querySubwayGroupReport`, { params })
};
//重置直钻超总览店铺关注指标维度
export const resetOverviewIndexDimension = params => {
  return axios.get(`/overview/resetOverviewIndexDimension`, { params })
};





//修改直通车总览指标维度
export const updateSubwayIndexDimension = params => {
  return axios.get(`/overview/updateSubwayIndexDimension`, { params })
};
//查询直通车历史数据
export const querySubwayHistoryData = params => {
  return axios.get(`/overview/querySubwayHistoryData`, { params })
};

//查询总览历史数据
export const getOverviewHistoryData = params => {
  return axios.get(`/overview/getOverviewHistoryData`, { params })
};

export const querySubwayHistoryLineChart = params => {
  return axios.get(`/overview/querySubwayHistoryLineChart`, { params })
};
//获取转化周期
export const getEffectInfo = params => {
  return axios.get(`/dict/queryDictInfos`, { params })
};
//获取超级推荐历史数据
export const queryRecommendHistoryData = params => {
  return axios.get(`/overview/queryRecommendHistoryData`, { params })
};
// 分渠道折线图
export const queryRecommendHistoryLineChart = params => {
  return axios.get(`/overview/queryRecommendHistoryLineChart`, { params })
};
// 改版分渠道折线图
export const queryChannelHistoryPolyline = params => {
  return axios.get(`/overview/queryChannelHistoryPolyline`, { params })
};

//超级推荐-关键词投放 获取关键词列表
export const findTagKeywordInfo = params => {
  return axios.post(`/putKeyWord/findTagKeywordInfo`, params)
};
//查看关键词
export const findKeywordInfoByTagId = params => {
  return axios.get(`/putKeyWord/findKeywordInfoByTagId`, { params })
};
//查询直通车创意列表
export const querySubwayCreativeReport = params => {
  return axios.get(`/subwayCreative/querySubwayCreativeReport`, { params })
};

//查询直通车创意报表计划列表
export const querySubCreCampaignList = params => {
  return axios.get(`/subwayCreative/querySubCreCampaignList`, { params })
};
//查询直通车创意报表单元列表
export const querySubCreAdgroupList = params => {
  return axios.get(`/subwayCreative/querySubCreAdgroupList`, { params })
};
// 查询直通车创意报表创意列表
export const querySubCreCreativeList = params => {
  return axios.get(`/subwayCreative/querySubCreCreativeList`, { params })
};
//下载创意表现报表
export const downloadSubwayCreativeReport = params => {
  return axios.get(`/subwayCreative/downloadSubwayCreativeReport`, { params, responseType: "blob", hideLoading: true })
};
//人群表现报表
export const querySubwayGroupKeywordReport = params => {
  return axios.get(`/keywordReport/querySubwayGroupKeywordReport`, { params })
};
//查询渠道总览历史数据
export const getChannelHistoryData = params => {
  return axios.get(`/overview/getChannelHistoryData`, { params })
};

//计划级- 直通车报表
export const queryPromotionList = params => {
  return axios.get(`/overview/queryPromotionList`, { params })
};
//人群表现报表 下载
export const downloadSubwayGroupKeywordReport = params => {
  return axios.get(`/keywordReport/downloadSubwayGroupKeywordReport`, { params, responseType: "blob" })
};
//计划-直通车-表现报表 下载
export const downloadPromotionPlan = params => {
  return axios.get(`/overview/downloadPromotionPlan`, { params, responseType: "blob" })
};

//账户级报表
export const queryOverviewHistoryData = params => {
  return axios.get(`/overview/queryOverviewHistoryData`, { params })
};
//账户级报表下载
export const downloadOverviewHistoryData = params => {
  return axios.get(`/overview/downloadOverviewHistoryData`, { params, responseType: "blob" })
};
//超级推荐 智能推广
//查询任务信息
export const queryTaskInfo = params => {
  return axios.post(`/changePrice/queryTaskInfo`, params)
};
//保存任务信息
export const editTaskInfo = params => {
  return axios.post(`/changePrice/editTaskInfo`, params)
};
//查询任务详情
export const getTaskInfoById = params => {
  return axios.get(`/changePrice/getTaskInfoById`, { params })
};
//删除任务
export const deleteTask = params => {
  return axios.get(`/changePrice/deleteTask`, { params })
};
//执行任务
export const startOrPauseTask = params => {
  return axios.get(`/changePrice/startOrPauseTask`, { params })
};
//实时获取投放中的计划信息
export const onlineCampaignInfo = params => {
  return axios.get(`/changePrice/onlineCampaignInfo`, { params })
};
//保存规则信息
export const addRuleByTaskId = params => {
  return axios.post(`/changePrice/addRuleByTaskId`, params)
};
//获取推广计划日限额
export const getCampaignBudgetById = params => {
  return axios.get(`/changePrice/getCampaignBudgetById`, { params })
};
//超级推荐智能改价日志
//获取需对其下人群进行调价的单元名称
export const getAdGroupNameList = params => {
  return axios.get(`/changePriceLog/getAdGroupNameList`, { params })
};
//查询推广单元执行时间列表
export const getAdOrCrowdExecuteTime = params => {
  return axios.post(`/changePriceLog/getAdOrCrowdExecuteTime`, params, { hideLoading: true })
};
//根据推广单元ID查询人群信息
export const getCrowdInfoByAdGroup = params => {
  return axios.post(`/changePriceLog/getCrowdInfoByAdGroup`, params, { hideLoading: true })
};
//根据任务ID查询任务执行的时间列表
export const getDatesByTaskId = params => {
  return axios.get(`/changePriceLog/getDatesByTaskId`, { params })
};
//分页查询单元日志信息
export const queryAdGroupLog = params => {
  return axios.post(`/changePriceLog/queryAdGroupLog`, params)
};
//分页查询人群日志信息
export const queryCrowdLog = params => {
  return axios.post(`/changePriceLog/queryCrowdLog`, params)
};

//直通车-自动投放-自动加词
//获取任务列表
export const queryKeywordTaskInfo = params => {
  return axios.post(`/autoAddKeyWord/queryKeywordTaskInfo`, params)
};
//保存自动加词任务
export const editKeywordTaskInfo = params => {
  return axios.post(`/autoAddKeyWord/editKeywordTaskInfo`, params)
};
//获取自动加词任务详情
export const keywordTaskDetail = params => {
  return axios.get(`/autoAddKeyWord/keywordTaskDetail`, { params })
};
//获取推广计划及其推广单元信息
export const autoAddKeyWordCampaigns = params => {
  return axios.get(`/autoAddKeyWord/campaigns`, { params })
};
//获取关键词指标
export const keywordTarget = params => {
  return axios.get(`/autoAddKeyWord/keywordTarget`, { params })
};
//智能加词任务添加规则信息
export const addKeywordRuleByTaskId = params => {
  return axios.post(`/autoAddKeyWord/addKeywordRuleByTaskId`, params)
};
//执行或者停止任务信息
export const autoAddStartOrPauseTask = params => {
  return axios.get(`/autoAddKeyWord/startOrPauseTask`, { params })
};
//删除任务信息
export const autoAddeleteTask = params => {
  return axios.get(`/autoAddKeyWord/deleteTask`, { params })
};
//获取推荐关键词的推广计划和单元信息：
export const autoAddWordAdGroup = params => {
  return axios.get(`/autoAddKeyWord/wordAdGroup`, { params })
};
export const autoAddWordDetail = params => {
  return axios.get(`/autoAddKeyWord/wordDetail`, { params })
};
//判断关键词是否添加
export const isPutKeyword = params => {
  return axios.get(`/autoAddKeyWord/isPutKeyword`, { params })
};
//添加关键词到计划
export const addKeyword = params => {
  return axios.get(`/autoAddKeyWord/addKeyword`, { params })
};
//获取使用规则
export const ruleTemplate = params => {
  return axios.get(`/ruleTemplate/queryTemplate`, { params })
};
//保存规则
export const ruleTemplateEdit = params => {
  return axios.post(`/ruleTemplate/editTemplate`, params)
};
//获取规则模板
export const queryRuleJsonByTemplate = params => {
  return axios.get(`/ruleTemplate/queryRuleJsonByTemplate`, { params })
};
//得到所有指标字典
export const queryDictInfos = params => {
  return axios.get(`/dict/queryDictInfos`, { params })
};
//得到用户当前关注的指标
export const getRecordIndex = params => {
  return axios.get(`/addKeyWord/getRecordIndex`, { params })
};
//更改用户关注指标
export const updRecordIndex = params => {
  return axios.post(`/addKeyWord/updRecordIndex`, params)
};
//根据条件（关键词，转化周期，时间）用户指标数
export const getKeyWordListByKeyWord = params => {
  return axios.post(`/addKeyWord/getKeyWordListByKeyWord`, params)
};
//根据条件查询关键词所在推广组和推广计划
export const queryKeyWordAndCampaign = params => {
  return axios.post(`/addKeyWord/queryKeyWordAndCampaign`, params)
};
//删除关键词
export const deleteSubwayCampaignKeyword = params => {
  return axios.post(`/addKeyWord/deleteSubwayCampaignKeyword`, params)
};
//查询店铺当前的计划列表
export const querySubwayCampaignWithNormalAndStar = params => {
  return axios.get(`/changeKeyWord/querySubwayCampaignWithNormalAndStar`, { params })
};[]
// 暂停或者推广某个计划
export const updateSubwayCampaignStatus = params => {
  return axios.get(`/changeKeyWord/updateSubwayCampaignStatus`, { params })
};
//修改计划得日限额
export const updateSubwayCampaignBudget = params => {
  return axios.post(`/changeKeyWord/updateSubwayCampaignBudget`, params)
};
//查询某个计划下的所有单元信息
export const querySubwayGroupByCampaignId = params => {
  return axios.get(`/changeKeyWord/querySubwayGroupByCampaignId`, { params })
};
//添加直通车筛选关键词任务
export const createSubwayKeywordFilterScheduleJob = params => {
  return axios.post(`/changeKeyWord/createSubwayKeywordFilterScheduleJob`, params)
};

//下载模板
export const downloadAddGoodsModel = params => {
  return axios.get(`/recommendMerchandise/downloadAddGoodsModel`, { params, responseType: "blob" })
};
//超推导入商品数据
export const uploadAddGoodInfos = params => {
  return axios.post(`/recommendMerchandise/uploadAddGoodInfos`, params, { headers: { 'Content-Type': 'multipart/form-data' } })
};
//批量查询推广组下关键词数量
export const queryKeywordNumsByGroupId = params => {
  return axios.get(`/putKeyWord/queryKeywordNumsByGroupId`, { params })
};

// 月份选择下拉框
export const queryBudgetMonthList = params => {
  return axios.get(`/overview/queryBudgetMonthList`, { params })
};

//据渠道和月份查询计划预算信息
export const queryBudgetByChannelAndMonth = params => {
  return axios.get(`/overview/queryBudgetByChannelAndMonth`, { params })
};

// 下载计算预算模板
export const downloadCampaignBudgetTemplate = params => {
  return axios.get(`/overview/downloadCampaignBudgetTemplate`, { params, responseType: "blob" })
};

//上传预算
export const uploadCampaignBudgetTemplate = params => {
  return axios.post(`/overview/uploadCampaignBudgetTemplate`, params, { headers: { 'Content-Type': 'multipart/form-data' } })
};

//添加直通车筛选关键词任务
export const batchUpdateCampaignBudget = params => {
  return axios.post(`/overview/batchUpdateCampaignBudget`, params)
};

//修改某个计划日限额
export const updateCampaignBudget = params => {
  return axios.get(`/overview/updateCampaignBudget`, { params })
};

// 查询计划带日限额
export const querySubwayCampaignDaily = params => {
  return axios.get(`/changeKeyWord/querySubwayCampaignDaily`, { params })
};

// 获取店铺的分时累计花费期望值模板
export const querySubwayDayPartingModel = params => {
  return axios.get(`/changeKeyWord/querySubwayDayPartingModel`, { params })
};

// 新增/修改模板
export const addOrUpdSubwayDayPartingModel = params => {
  return axios.post(`/changeKeyWord/addOrUpdSubwayDayPartingModel`, params)
};

//删除某店铺下的某一模板
export const deleteSubwayDayPartingModel = params => {
  return axios.get(`/changeKeyWord/deleteSubwayDayPartingModel`, { params })
}

// 保存当前设置模板用来回显
export const savaSubwayDayPartingModel = params => {
  return axios.post(`/changeKeyWord/savaSubwayDayPartingModel`, params)
};

//回显
export const getSubwayDayPartingModel = params => {
  return axios.get(`/changeKeyWord/getSubwayDayPartingModel`, { params })
}
//查询单元花费阈值模板
export const queryKeywordAutoChangePriceModel = params => {
  return axios.get(`/changeKeyWord/queryKeywordAutoChangePriceModel`, { params })
}

//删除自动调价规则模板
export const deleteKeywordAutoChangePriceModel = params => {
  return axios.get(`/changeKeyWord/deleteKeywordAutoChangePriceModel`, { params })
}

// 新增调价规则
export const addOrUpdKeywordAutoChangePriceModel = params => {
  return axios.post(`/changeKeyWord/addOrUpdKeywordAutoChangePriceModel`, params)
};

// 查询店铺在执行任务列表
export const querySubwayKeywordChangePriceJob = params => {
  return axios.post(`/changeKeyWord/querySubwayKeywordChangePriceJob`, params)
};
// 得到任务参数详情
// getJobDetailsByRecordId

export const getJobDetailsByRecordId = params => {
  return axios.get(`/changeKeyWord/getJobDetailsByRecordId`, { params })
}

// 获取计划列表
export const querySubwayAutoChangePrinceCampaigns = params => {
  return axios.get(`/changeKeyWord/querySubwayAutoChangePrinceCampaigns`, { params })
}
// 获取商品列表
export const querySubwayAutoChangePrinceGroups = params => {
  return axios.get(`/changeKeyWord/querySubwayAutoChangePrinceGroups`, { params })
}
// 获取关键词
export const querySubwayAutoChangePrinceKeywords = params => {
  return axios.get(`/changeKeyWord/querySubwayAutoChangePrinceKeywords`, { params })
}
//
// 查询直通车自动改价日志
export const querySubwayAutoChangePrinceLogs = params => {
  return axios.post(`/changeKeyWord/querySubwayAutoChangePrinceLogs`, params)
}
// 下载直通车自动改价日志
export const downloadSubwayAutoChangePrinceLogs = params => {
  return axios.post(`/changeKeyWord/downloadSubwayAutoChangePrinceLogs`, params, { responseType: "blob" })
};
// 暂停任务
export const startOrPauseSubwayChangePriceJob = params => {
  return axios.get(`/changeKeyWord/startOrPauseSubwayChangePriceJob`, { params })
};
// 删除任务
export const deleteSubwayChangePriceJob = params => {
  return axios.get(`/changeKeyWord/deleteSubwayChangePriceJob`, { params })
};
// 查询直通车调价历史数据日期列表
export const querySubwayKeywordHistoryDate = params => {
  return axios.get(`/changeKeyWord/querySubwayKeywordHistoryDate`, { params })
};

//查询直通车调价历史数据
export const querySubwayKeywordHistoryData = params => {
  return axios.post(`/changeKeyWord/querySubwayKeywordHistoryData`, params)
};

//查询直通车调价历史分日数据
export const querySubwayKeywordHistoryDataByDay = params => {
  return axios.post(`/changeKeyWord/querySubwayKeywordHistoryDataByDay`, params)
};

// 下载直通车分天数据
export const downloadSubwayKeywordHistoryDataByDay = params => {
  return axios.post(`/changeKeyWord/downloadSubwayKeywordRealTimeData`, params, { responseType: "blob" })
};

// 下载直通车历史数据
export const downloadSubwayKeywordHistoryData = params => {
  return axios.post(`/changeKeyWord/downloadSubwayKeywordHistoryData`, params, { responseType: "blob" })
};


//查询直通车调价历史数据折线图
export const querySubwayKeywordHistoryDateLineChart = params => {
  return axios.get(`/changeKeyWord/querySubwayKeywordHistoryDateLineChart`, { params })
};

// 查询直通车关键词实时数据
export const querySubwayKeywordRealTimeData = params => {
  return axios.post(`/changeKeyWord/querySubwayKeywordRealTimeData`, params)
};

//直通车关键词实时数据折线图
export const querySubwayKeywordRealTimeLineChart = params => {
  return axios.get(`/changeKeyWord/querySubwayKeywordRealTimeLineChart`, { params })
};

// 快捷删词获取关键词
export const queryKeywordReportByCampaign = (params) => {
  return axios.post(`addKeyWord/queryKeywordReportByCampaign`, params)
};

export const findAdGroupInfoByCampaignIds = (params) => {
  return axios.get(`/addKeyWord/findAdGroupInfoByCampaignIds`, { params })
}

export const queryKeywordInfoByGroupId = (params) => {
  return axios.get('/addKeyWord/queryKeywordInfoByGroupId', { params })
}
// 查询超推计划（全部）
export const getRecCampaigns = (params) => {
  return axios.get('/overview/getRecCampaigns', { params })
}

// 查询调价默认模板
export const queryKeywordAutoChangeDefaultModel = (params) => {
  return axios.get('/changeKeyWord/queryKeywordAutoChangeDefaultModel', { params })
}

// 设置品牌专区花费
export const insertBrandPrefectureCost = (params) => {
  return axios.get('/overview/insertBrandPrefectureCost', { params })
}

// 下载直通车调价实时数据
export const downloadOverviewRealAndForecastDatas = (params) => {
  return axios.get('/overview/downloadOverviewRealAndForecastDatas', { params, responseType: "blob" })
  //
}

// 查看店铺下关键词标签以及操作人(用于下拉)
export const queryKeywordLabelDownPull = (params) => {
  return axios.post(`/subwayReport/queryKeywordLabelDownPull`, params)
};

// 查看店铺下关键词标签
export const queryKeywordLabelByShop = (params) => {
  return axios.post(`/subwayReport/queryKeywordLabelByShop`, params)
};

// 新增/修改关键词标签
export const addOrUpdKeywordLabel = (params) => {
  return axios.post(`/subwayReport/addOrUpdKeywordLabel`, params)
};

// 查询关键词标签详情
export const getKeywordLabelByLabelId = (params) => {
  return axios.get(`/subwayReport/getKeywordLabelByLabelId`, { params })
};

// 删除关键词标签
export const delKeywordLabel = (params) => {
  return axios.get('/subwayReport/delKeywordLabel', { params })
}

// 根据规则匹配关键词
export const batchMatchKeyword = (params) => {
  return axios.post(`/subwayReport/batchMatchKeyword`, params)
};

// 直通车报表-概览数据-获取实时数据以及预测
export const querySubwayRealReport = (params) => {
  return axios.get(`/subwayReport/querySubwayRealReport`, { params });
};

// 直通车报表-概览数据-表格明细-查询对比数据
export const queryDetailTableData = (params) => {
  return axios.get(`/subwayReport/queryDetailTableData`, { params });
};

// 下载分渠道分天以及分时所有指标的数据
export const downloadByDayAndByHourAllIndexData = (params) => {
  return axios.get(`/overview/downloadByDayAndByHourAllIndexData`, { params, responseType: "blob" });
};

// 直通车报表-概览数据-明细表格-下载对比数据
export const downloadDetailTableData = (params) => {
  return axios.get(`/subwayReport/downloadDetailTableData`, { params, responseType: "blob" });
};

// 直通车报表-明细数据-账户级对比数据
export const queryAccountSubwayReport = (params) => {
  return axios.get(`/subwayReport/queryAccountSubwayReport`, { params });
};

// 直通车报表-明细数据-下载账户级对比数据
export const downloadAccountSubwayReport = (params) => {
  return axios.get(`/subwayReport/downloadAccountSubwayReport`, { params, responseType: "blob" });
};

// 直通车报表-明细数据-下载计划级对比数据（上）
export const downloadCampaignSubwayReport = (params) => {
  return axios.post(`/subwayReport/downloadCampaignSubwayReport`, params, { responseType: "blob" })
};

// 直通车报表-明细数据-下载单元级对比数据（下）
export const downloadGroupSubwayReport = (params) => {
  return axios.post(`/subwayReport/downloadGroupSubwayReport`, params, { responseType: "blob" })
};

// 直通车报表-明细数据-计划单元报表-查询计划列表
export const queryCampaignListByTimeDimension = (params) => {
  return axios.get(`/subwayReport/queryCampaignListByTimeDimension`, { params });
};

// 直通车报表-明细数据-计划级对比数据（计划单元报表上）
export const queryCampaignSubwayReport = (params) => {
  return axios.post(`/subwayReport/queryCampaignSubwayReport`, params)
};

// 直通车报表-明细数据-单元级对比数据（计划单元报表下）
export const queryGroupSubwayReport = (params) => {
  return axios.post(`/subwayReport/queryGroupSubwayReport`, params)
};

// 直通车报表-明细数据-计划单元报表-查询单元列表
export const queryGroupListByTimeDimension = (params) => {
  return axios.post(`/subwayReport/queryGroupListByTimeDimension`, params)
};

// 直通车报表-明细数据-商品-新增类目
export const addCategory = (params) => {
  return axios.get(`/subwayReport/addCategory`, { params });
};

// 通车报表-明细数据-商品-删除类目
export const removeCategory = (params) => {
  return axios.get(`/subwayReport/removeCategory`, { params });
};

// 直通车报表-明细数据-商品-绑定分类至商品上
export const bindGoodsOnCategory = (params) => {
  return axios.post(`/subwayReport/bindGoodsOnCategory`, params)
};

// 直通车报表-明细数据-商品-下载商品明细数据（上）
export const downloadGoodsSubwayReport = (params) => {
  return axios.post(`/subwayReport/downloadGoodsSubwayReport`, params, { responseType: "blob" })
};

// 直通车报表-明细数据-商品-查询商品列表以及商品类目列表
export const queryGoodsAndCategory = (params) => {
  return axios.get(`/subwayReport/queryGoodsAndCategory`, { params });
};

// 直通车报表-明细数据-商品-查看商品明细数据
export const queryGoodsSubwayReport = (params) => {
  return axios.post(`/subwayReport/queryGoodsSubwayReport`, params)
};

// 商品-添加/取消关注
export const operateGoodsAttention = (params) => {
  return axios.get(`/subwayReport/operateGoodsAttention`, { params });
};

// 商品-根据商品id查询计划列表
export const queryCampaignByGoods = (params) => {
  return axios.post(`/subwayReport/queryCampaignByGoods`, params)
};

// // 引力魔方日限额管理——模板下载
export const downloadDisplayCampaign = (params) => {
  return axios.get(`/displayCampaign/downloadDisplayCampaign`, { params, responseType: "blob" })
}
// 计划组查询
export const getCampaignGroup = (params) => {
  return axios.get(`displayCampaign/getCampaignGroup`, params)
}

// 计划名称下拉
export const getCampaign = (params) => {
  return axios.get(`displayCampaign/getCampaign`, { params })
}
// 查询主体
export const promtionType = (params) => {
  return axios.get(`displayCampaign/getPromtionType`, params)
}

// 引力魔方上传数据
export const uploadDisplayCampaign = (params) => {
  return axios.post(`displayCampaign/uploadDisplayCampaign`, params)
}

// 引力魔方查询计划列表
export const getDisplayCampaignList = (params) => {
  return axios.post(`displayCampaign/getDisplayCampaignList`, params)
}
//引力魔方日限额修改列表
export const updateDisplayCampaign = (params) => {
  return axios.post(`displayCampaign/updateDisplayCampaign`, params)
}

// 引力魔方日限额修改彈框
export const updateDisplayCampaignList = (params) => {
  return axios.post(`displayCampaign/updateDisplayCampaignList`, params)
}
//批量上下品  引力魔方日限额   批量根据商品id获取所投放的单元以及计划信息
export const queryCampaignInfoByGoodsId = (params) => {
  return axios.post(`goodsUpAndDown/queryCampaignInfoByGoodsId`, params)
}

//批量上下品  引力魔方日限额  批量根据商品id匹配商品
export const batchMatchByGoodsId = (params) => {
  return axios.post(`goodsUpAndDown/batchMatchByGoodsId`, params)
}
//引力魔方人群管理定向明细数据
export const queryCubeCrowdReportByTimeDimension = (params) => {
  return axios.post(`cubeCrowd/queryCubeCrowdReportByTimeDimension`, params)
}

// 引力魔方人群管理定向明细表
export const queryCubeCrowdDetail = (params) => {
  return axios.post(`cubeCrowd/queryCubeCrowdDetail`, params)
}
// 引力魔方人群管理查询选择时间段、效果、转化周期内所有定向列表
export const queryCubeCrowdListByTimeDimension = (params) => {
  return axios.post(`cubeCrowd/queryCubeCrowdListByTimeDimension`, params)
}
// 引力魔方人群管理查询选择时间段、效果、转化周期内所有定向列表
export const queryCubeCrowdList = (params) => {
  return axios.post(`cubeCrowd/queryCubeCrowdList`, params)
}
// 引力魔方人群管理 修改主体状态
export const batchUpdCubeAdgroupStatus = (params) => {
  return axios.post(`cubeCrowd/batchUpdCubeAdgroupStatus`, params)
}
export const updateOverviewIndexCubeCrowd = params => {
  return axios.get(`/cubeCrowd/updateOverviewIndexCubeCrowd`, { params })
}

// 引力魔方人群管理 修改出价
export const batchUpdCubeCrowdPrice = (params) => {
  return axios.post(`cubeCrowd/batchUpdCubeCrowdPrice`, params)
}
// 引力魔方人群管理  明细数据表格计划下拉框
export const queryCubeCrowdCampaignList = (params) => {
  return axios.post(`cubeCrowd/queryCubeCrowdCampaignList`, params)
}

// 引力魔方人群管理  明细数据表格计划组下拉框
export const queryCubeCrowdCampaignGroupList = (params) => {
  return axios.post(`cubeCrowd/queryCubeCrowdCampaignGroupList`, params)
}

// 引力魔方人群管理  明细数据表格商品(主体)下拉框
export const queryCubeCrowdPromotionEntityList = (params) => {
  return axios.post(`cubeCrowd/queryCubeCrowdPromotionEntityList`, params)
}
// 引力魔方批量上下品  修改单元状态

export const updAdGroupStatus = (params) => {
  return axios.post(`goodsUpAndDown/updAdGroupStatus`, params)
}


// 引力魔方总览-概览数据-获取实时数据以及预测
export const queryCubeAccountOverview = params => {
  return axios.get(`/cubeOverview/queryCubeAccountOverview`, { params })
}

//  引力魔方总览-概览数据-显示分时数据
export const cubequeryDatasByHour = params => {
  return axios.get(`/cubeOverview/queryDatasByHour`, { params })
}

//  引力魔方总览-概览数据-显示分天数据
export const cubequeryDataByDay = params => {
  return axios.get(`/cubeOverview/queryDataByDay`, { params })
}
// 引力魔方总览-下载引力魔方渠道分天以及分时所有指标的数据
export const cubedownloadByDayAndByHourAllIndexData = params => {
  return axios.get(`/cubeOverview/downloadByDayAndByHourAllIndexData`, { params, responseType: "blob" })
}

// 引力魔方总览- 概览数据表格明细

export const cubequeryDetailTableData = params => {
  return axios.get(`/cubeOverview/queryDetailTableData`, { params })
}
// 引力魔方总览- 下载概览数据表格明细
export const cubedownloadDetailTableData = params => {
  return axios.get(`/cubeOverview/downloadDetailTableData`, { params, responseType: "blob" })
}

// 引力魔方总览- 引力魔方渠道账户维度历史数据折线图
export const queryAccountHistoryReport = (params) => {
  return axios.post(`cubeOverview/queryAccountHistoryReport`, params)
}
//  引力魔方总览- 引力魔方渠道账户维度历史数据
export const queryAccountHistoryRpt = (params) => {
  return axios.post(`cubeOverview/queryAccountHistoryRpt`, params)
}
//引力魔方总览-  下载引力魔方账户维度历史数据报表
export const downloadAccountHistoryRpt = (params) => {
  return axios.post(`cubeOverview/downloadAccountHistoryRpt`, params, { responseType: "blob" })
}

//  引力魔方总览- 引力魔方渠道计划 计划组汇总数据下拉框  查询计划组列表 历史数据
export const queryCampaignGroupList = (params) => {
  return axios.get(`/cubeOverview/queryCampaignGroupList`, { params })
}
//  引力魔方总览- 引力魔方渠道计划 计划组id查询计划列表 计划下拉框
export const queryCampaignByGroupIds = (params) => {
  return axios.post(`cubeOverview/queryCampaignByGroupIds`, params)
}

//  引力魔方总览- 引力魔方渠道计划 计划组汇总数据  查询计划组报表 历史数据
export const queryCampaignGroupHistoryRpt = (params) => {
  return axios.post(`cubeOverview/queryCampaignGroupHistoryRpt`, params)
}

//  引力魔方总览- 引力魔方渠道计划  计划历史数据报表
export const queryCampaignHistoryRpt = (params) => {
  return axios.post(`cubeOverview/queryCampaignHistoryRpt`, params)
}
//  引力魔方总览- 引力魔方渠道计划  下载计划组报表数据
export const downloadCampaignGroupHistoryRpt = (params) => {
  return axios.post(`cubeOverview/downloadCampaignGroupHistoryRpt`, params, { responseType: "blob" })
}

//  引力魔方总览- 引力魔方渠道计划  下载计划组报表数据
export const downloadCampaignHistoryRpt = (params) => {
  return axios.post(`cubeOverview/downloadCampaignHistoryRpt`, params, { responseType: "blob" })
}

//  引力魔方总览- 引力魔方渠道计划  查询店铺预警规则
export const queryCubeCampaignWarningInfos = (params) => {
  return axios.get(`/cubeOverview/queryCubeCampaignWarningInfos`, { params })
}
//  引力魔方总览- 引力魔方渠道计划 添加店铺预警规则 
export const updateOrAddCampaignWarningInfos = (params) => {
  return axios.post(`cubeOverview/updateOrAddCampaignWarningInfos`, params)
}

//  引力魔方总览- 引力魔方渠道计划  删除店铺预警规则
export const deleteCampaignWarningInfos = (params) => {
  return axios.get(`/cubeOverview/deleteCampaignWarningInfos`, { params })
}

//  引力魔方总览- 引力魔方  查询商品报表数据
export const queryGoodsRpt = (params) => {
  return axios.post(`cubeOverview/queryGoodsRpt`, params)
}

//  引力魔方总览- 引力魔方总览  商品分类标签添加
export const addGoodsCategory = (params) => {
  return axios.get(`/cubeOverview/addGoodsCategory`, { params })
}
//  引力魔方总览- 引力魔方商品  商品分类标签删除
export const removeGoodsCategory = (params) => {
  return axios.get(`/cubeOverview/removeGoodsCategory`, { params })
}

//  引力魔方总览- 引力魔方  绑定分类标签到商品
export const bindCategoryOnGoods = (params) => {
  return axios.post(`cubeOverview/bindCategoryOnGoods`, params)
}

//  引力魔方总览- 引力魔方商品  查询店铺下的分类标签列表
export const queryCategoryList = (params) => {
  return axios.get(`/cubeOverview/queryCategoryList`, { params })
}
//  引力魔方总览- 引力魔方  查询商品明细报表数据
export const queryGoodsDetailRpt = (params) => {
  return axios.post(`cubeOverview/queryGoodsDetailRpt`, params)
}

//  引力魔方总览- 引力魔方  查询商品明细报表数据
export const queryGoodsCampaignPromotion = (params) => {
  return axios.post(`cubeOverview/queryGoodsCampaignPromotion`, params)
}
//  引力魔方总览- 引力魔方渠道计划  下载商品报表
export const downloadGoodsRpt = (params) => {
  return axios.post(`cubeOverview/downloadGoodsRpt`, params, { responseType: "blob" })
}

//  引力魔方总览- 引力魔方渠道计划  下载商品报表
export const downloadGoodsDetailRpt = (params) => {
  return axios.post(`cubeOverview/downloadGoodsDetailRpt`, params, { responseType: "blob" })
}
//  引力魔方总览- 引力魔方渠道计划  查询商品列表
export const queryGoodsCampaignPromotionList = (params) => {
  return axios.post(`cubeOverview/queryGoodsCampaignPromotionList`, params)
}

//  引力魔方总览- 引力魔方渠道计划  查询计划组列表
export const queryGoodsCampaignGroupList = (params) => {
  return axios.post(`cubeOverview/queryGoodsCampaignGroupList`, params)
}

//  引力魔方总览- 引力魔方渠道定向 批量移除定向
export const batchRemoveCubeCrowd = (params) => {
  return axios.post(`cubeCrowd/batchRemoveCubeCrowd`, params)
}

//  引力魔方总览- 引力魔方渠道定向 批量移除定向
export const queryGoodsCampaignList = (params) => {
  return axios.post(`cubeOverview/queryGoodsCampaignList`, params)
}

//  引力魔方总览- 引力魔方渠道资源位  查询-上表查询资源位汇总数据
export const queryCubeAdzoneRpt = (params) => {
  return axios.post(`cubeAdzone/queryCubeAdzoneRpt`, params)
}
//  引力魔方总览- 引力魔方渠道资源位 下拉列表-资源位名称
export const queryAdzoneNameList = (params) => {
  return axios.post(`/cubeAdzone/queryAdzoneNameList`, params)
}
//  引力魔方总览- 引力魔方渠道资源位  查询-下表-下拉列表计划组信息
export const queryAdzoneCampaignGroupList = (params) => {
  return axios.post(`cubeAdzone/queryCampaignGroupList`, params)
}

//  引力魔方总览- 引力魔方渠道资源位  查询-下表-下拉列表计划信息
export const queryCampaignList = (params) => {
  return axios.post(`cubeAdzone/queryCampaignList`, params)
}
//  引力魔方总览- 引力魔方渠道资源位  查询-下表 下拉列表主体商品信息
export const queryAdzonePromotionList = (params) => {
  return axios.post(`cubeAdzone/queryPromotionList`, params)
}
//  引力魔方总览- 引力魔方渠道资源位  查询-下表 下拉列表主体商品信息
export const queryCubeAdzoneDetailRpt = (params) => {
  return axios.post(`cubeAdzone/queryCubeAdzoneDetailRpt`, params)
}
//  引力魔方总览- 引力魔方渠道资源位  上表-资源位下拉列表
export const queryCubeAdzoneNameList = (params) => {
  return axios.post(`cubeAdzone/queryCubeAdzoneNameList`, params)
}


//  引力魔方总览- 引力魔方渠道计划  下载-上表资源位汇总数据
export const downloadCubeAdzoneRpt = (params) => {
  return axios.post(`cubeAdzone/downloadCubeAdzoneRpt`, params, { responseType: "blob" })
}

//  引力魔方总览- 引力魔方渠道计划  下表查询资源位明细数据
export const downloadCubeAdzoneDetailRpt = (params) => {
  return axios.post(`cubeAdzone/downloadCubeAdzoneDetailRpt`, params, { responseType: "blob" })
}

//  引力魔方总览- 引力魔方渠道资源位  查询创意报表
export const queryCubeCreativeRpt = (params) => {
  return axios.post(`cubeOverview/queryCubeCreativeRpt`, params)
}

//  引力魔方总览- 引力魔方渠道资源位 创意报表-计划组下拉列表
export const queryCubeCreativeCampaignGroupList = (params) => {
  return axios.post(`cubeOverview/queryCubeCreativeCampaignGroupList`, params)
}

//  引力魔方总览- 引力魔方渠道资源位 创意报表-计划下拉列表
export const queryCubeCreativeCampaignList = (params) => {
  return axios.post(`cubeOverview/queryCubeCreativeCampaignList`, params)
}
//  引力魔方总览- 引力魔方渠道资源位 创意报表-商品Id下拉列表
export const queryCubeCreativeGoodsIdList = (params) => {
  return axios.post(`cubeOverview/queryCubeCreativeGoodsIdList`, params)
}

//  引力魔方总览- 引力魔方渠道资源位 创意报表-创意名称下拉列表
export const queryCubeCreativeNameList = (params) => {
  return axios.post(`cubeOverview/queryCubeCreativeNameList`, params)
}
//  引力魔方总览- 引力魔方渠道资源位 创意报表-主体下拉列表
export const queryCubeCreativePromotionList = (params) => {
  return axios.post(`cubeOverview/queryCubeCreativePromotionList`, params)
}
//  引力魔方总览- 引力魔方渠道计划  下载创意报表
export const downloadCubeCreativeRpt = (params) => {
  return axios.post(`cubeOverview/downloadCubeCreativeRpt`, params, { responseType: "blob" })
}


// 关键词-(下拉)关键词-获取关键词列表
export const querySubwayReportKeywordList = (params) => {
  return axios.get(`/subwayReport/querySubwayReportKeywordList`, { params });
};
// 关键词-明细数据-关键词-关键词报表
export const queryKeywordSubwayReport = (params) => {
  return axios.post(`/subwayReport/queryKeywordSubwayReport`, params)
};
// 关键词-计划下拉
export const queryCampaignListForKeywordSubwayReport = (params) => {
  return axios.get(`/subwayReport/queryCampaignListForKeywordSubwayReport`, { params });
};
// 关键词-单元下拉
export const queryGroupListForCampaignSubwayReport = (params) => {
  return axios.get(`/subwayReport/queryGroupListForCampaignSubwayReport`, { params });
};
// 关键词-商品下拉
export const queryGoodsListForGroupSubwayReport = (params) => {
  return axios.get(`/subwayReport/queryGoodsListForGroupSubwayReport`, { params });
};
// 关键词-关键词表格报表
export const queryKeywordTableSubwayReport = (params) => {
  return axios.post(`/subwayReport/queryKeywordTableSubwayReport`, params)
};
// 关键词-下载关键词报表
export const downloadKeywordSubwayReport = params => {
  return axios.post(`/subwayReport/downloadKeywordSubwayReport`, params, { responseType: "blob" })
};
// 关键词-下载关键词表格报表
export const downloadKeywordTableSubwayReport = params => {
  return axios.post(`/subwayReport/downloadKeywordTableSubwayReport`, params, { responseType: "blob" })
};
// 关键词-批量修改关键词标签
export const batchUpdKeywordLabel = params => {
  return axios.post(`/subwayReport/batchUpdKeywordLabel`, params)
};




// 人群-人群信息以及类目下拉
export const queryCrowdNameListSubwayReport = (params) => {
  return axios.get(`/subwayReport/queryCrowdNameListSubwayReport`, { params });
};
// 人群-人群报表
export const queryCrowdSubwayReport = params => {
  return axios.post(`/subwayReport/queryCrowdSubwayReport`, params)
};
// 人群-下载人群报表
export const downloadCrowdSubwayReport = params => {
  return axios.post(`/subwayReport/downloadCrowdSubwayReport`, params, { responseType: "blob" })
};
// 人群-人群报表
export const addCrowdCategory = params => {
  return axios.get(`/subwayReport/addCrowdCategory`, { params })
};
// 人群-删除类目
export const removeCrowdCategory = params => {
  return axios.get(`/subwayReport/removeCrowdCategory`, { params })
};
// 人群-根据人群id查询计划列表
export const queryCampaignListByCrowd = params => {
  return axios.post(`/subwayReport/queryCampaignListByCrowd`, params)
};

// 人群-人群表格报表
export const queryCrowdTableSubwayReport = params => {
  return axios.post(`/subwayReport/queryCrowdTableSubwayReport`, params)
};
// 人群-下载人群报表
export const downloadCrowdTableSubwayReport = params => {
  return axios.post(`/subwayReport/downloadCrowdTableSubwayReport`, params, { responseType: "blob" })
};
// 人群-绑定人群至类目上
export const bindCrowdOnCategory = params => {
  return axios.post(`/subwayReport/bindCrowdOnCategory`, params)
};
// 人群-商品
export const queryGoodsListByTimeDimension = params => {
  return axios.post(`/subwayReport/queryGoodsListByTimeDimension`, params)
};



// 创意-获取创意筛选下拉列表
export const queryCreativeListSubwayReport = params => {
  return axios.post(`/subwayReport/queryCreativeListSubwayReport`, params)
};
// 创意-创意表格报表
export const queryCreativeTableSubwayReport = params => {
  return axios.post(`/subwayReport/queryCreativeTableSubwayReport`, params)
};

// 创意-导出创意表格报表
export const downloadCreativeTableSubwayReport = params => {
  return axios.post(`/subwayReport/downloadCreativeTableSubwayReport`, params, { responseType: "blob" })
};

//获取计划组及计划
export const queryCampaignGroupAndCampaign = params => {
  return axios.get(`/campaignAddCrowd/queryCampaignGroupAndCampaign`, { params })
};
//获取店铺人群列表
export const queryShopCrowdList = params => {
  return axios.get(`/campaignAddCrowd/queryShopCrowdList`, { params })
};
//批量获取人群出价
export const batchQueryCrowdBid = params => {
  return axios.post(`/campaignAddCrowd/batchQueryCrowdBid`, params, { hideLoading: true })
};

//批量绑定人群至计划下
export const batchBindCrowdOnCampaign = params => {
  return axios.post(`/campaignAddCrowd/batchBindCrowdOnCampaign`, params)
};

//获取计划下绑定的人群数量
export const getCrowdCountByCampaign = params => {
  return axios.post(`/campaignAddCrowd/getCrowdCountByCampaign`, params, { hideLoading: true })
};

// 获取渠道总览历史数据报表
export const getSubwayReportAccountHisData = params => {
  return axios.post(`/OverviewHistory/getSubwayReportAccountHisData`, params)
};

// 单渠道分天明细数据
export const getSingleOverviewHistoryData = params => {
  return axios.post(`/OverviewHistory/getSingleOverviewHistoryData`, params)
};

// 获取表头
export const getHeadAllIndexList = params => {
  return axios.get(`/OverviewHistory/getHeadAllIndexList`, { params, hideLoading: true })
};

// 汇总数据下载
export const downloadExcleData = params => {
  return axios.post(`/OverviewHistory/downloadExcleData`, params, { responseType: "blob" })
};

// 单渠道数据下载
export const singleDownloadExcleData = params => {
  return axios.post(`/OverviewHistory/singleDownloadExcleData`, params, { responseType: "blob" })
}
// 引力魔方批量上品
export const batchAddCubeGoodsInCampaign = (ifBinding, params) => {
  return axios.post(`/CubeAddGroupController/batchAddCubeGoodsInCampaign?ifBinding=${ifBinding}` ,params)
}

// 一键加词
// 获取表头
export const queryRecommendKeywords = params => {
  return axios.get(`/subwayReport/queryRecommendKeywords`, { params, })
};
// 数据汇总新配置看板

// 埋点
export const savePoint = (params) => {
  return axios.post(`/sys/log/save`, params, { hideLoading: true })
}


export const getNewHeadAllIndexList = params => {
  return axios.get(`/OverviewHistory/getNewHeadAllIndexList`, { params, })
};
// 修改数据汇总新配置看板
export const controlNewPanel = params => {
  return axios.get(`/OverviewHistory/controlNewPanel`, { params, })
};

// 商品总览
// 查询店铺下的分类标签列表
export const queryGoodsCategoryList = params => {
  return axios.get(`/GoodsOverview/queryGoodsCategoryList`, { params })
};
// 获取商品总览数据
export const getGoodsOveriewData = params => {
  return axios.post(`/GoodsOverview/getGoodsOveriewData`, params)
}
// 查询店铺下的获取表头 配置看板的所有指标
export const getGoodsHeadAllIndexList = (params,) => {
  return axios.post(`/GoodsOverview/getGoodsHeadAllIndexList`, params)
};
// 商品总览配置看板
export const goodsControlPanel = params => {
  return axios.post(`/GoodsOverview/goodsControlPanel`, params)
}
// 商品-删除类目
export const removeCategoryGood = params => {
  return axios.get(`/GoodsOverview/removeCategory`, { params })  
};
// 商品-新增类目
export const addCategoryGood = params => {
  return axios.get(`/GoodsOverview/addCategory`, { params })
};
// 商品-绑定商品至类目上
export const bindGoodsOnCategoryGood = params => {
  return axios.post(`/GoodsOverview/bindGoodsOnCategory`, params)
};
// 上传分类
export const uploadGoodsCategoryTemplate = (params) => {
  return axios.post(`/GoodsOverview/uploadGoodsCategoryTemplate`, params, { headers: { 'Content-Type': 'multipart/form-data' } })
};
// 下载分类模板
export const downloadGoodsCategoryTemplate = params => {
  return axios.post(`/GoodsOverview/downloadGoodsCategoryTemplate`, params, {responseType: "blob" })
};
// 商品-下载商品明细数据
export const downloadGoodsReport = params => {
  return axios.post(`/GoodsOverview/downloadGoodsReport`, params, { responseType: "blob" })
};

// 万相台
// 万相台总览-明细数据-场景级趋势图对比数据
export const queryDkxSceneChartReport = params => {
  return axios.get(`/dkxOverview/queryDkxSceneChartReport`, { params })  
};
// 万相台总览配置看板
export const dkxNewHeadAllIndexList = params => {
  return axios.get(`/dkxOverview/dkxNewHeadAllIndexList`, { params })  
};

// 万相台总览-明细数据-场景级明细对比数据

export const queryDkxSceneReport = params => {
  return axios.get(`/dkxOverview/queryDkxSceneReport`, { params })  
};
// 万相台总览-修改万相台总览配置看板

export const dkxControlNewPanel = params => {
  return axios.get(`/dkxOverview/dkxControlNewPanel`, { params })  
};

//万相台总览-下载场景明细数据
export const downloadDkxSceneReport = params => {
  return axios.get(`/dkxOverview/downloadDkxSceneReport`, { params, responseType: "blob" })
};
// 万相台总览-商品汇总数据
export const queryDkxOveriewGoodsReport = params => {
  return axios.post(`/dkxOverview/queryDkxOveriewGoodsReport`, params)
};
// 万相台总览-商品明细数据
export const queryDkxOveriewGoodsDetailReport = params => {
  return axios.post(`/dkxOverview/queryDkxOveriewGoodsDetailReport`, params)
};
// 万相台总览-商品明细数据-商品id下拉框
export const queryDKxGoodsDetailGoodsIdPulldown = params => {
  return axios.post(`/dkxOverview/queryDKxGoodsDetailGoodsIdPulldown`, params)
};
// 万相台总览-商品明细数据-计划id下拉框
export const queryDKxGoodsDetailCampaignIdPulldown = params => {
  return axios.post(`/dkxOverview/queryDKxGoodsDetailCampaignIdPulldown`, params)
};

// 万相台总览-下载商品明细数据
export const downloadDkxOveriewGoodsDetailReport = params => {
  return axios.post(`/dkxOverview/downloadDkxOveriewGoodsDetailReport`, params, { responseType: "blob" })
};
// 万相台总览-下载商品汇总数据
export const downloadDkxOveriewGoodsReport = params => {
  return axios.post(`/dkxOverview/downloadDkxOveriewGoodsReport`, params, { responseType: "blob" })
};
// 万相台总览-计划汇总数据

export  const queryDkxOveriewCampaignReport = params => {
  return axios.get(`/dkxOverview/queryDkxOveriewCampaignReport`, { params })  
};

// 万相台总览-计划明细数据-计划id下拉框
export const queryDKxCampaignDetailCampaignIdPulldown = params => {
  return axios.post(`/dkxOverview/queryDKxCampaignDetailCampaignIdPulldown`, params)
};
// 万相台总览-计划明细数据

export const queryDkxOveriewCampaignDetailReport = params => {
  return axios.post(`/dkxOverview/queryDkxOveriewCampaignDetailReport`, params)
};
// 万相台总览-下载计划汇总数据
export const downloadDkxOveriewCampaignReport = params => {
  return axios.get(`/dkxOverview/downloadDkxOveriewCampaignReport`, { params, responseType: "blob" })
};

// 万相台总览-下载计划明细数据
export const downloadDkxOveriewCampaignDetailReport = params => {
  return axios.post(`/dkxOverview/downloadDkxOveriewCampaignDetailReport`, params, { responseType: "blob" })
};

// 监控-获取所有任务名称
export const queryDataMonitorShowJobNameAll = params => {
  return axios.get(`/dataMonitorShowController/queryDataMonitorShowJobNameAll`, { params })
};

// 监控-获取数据拉取监测结果数据
export const queryDataMonitorShow = params => {
  return axios.get(`/dataMonitorShowController/queryDataMonitorShow`, { params })
};
// 万相台总览-实时数据-概览数据
export const queryDkxRealReport = params => {
  return axios.get(`/dkxOverview/queryDkxRealReport`, { params })
};
// 万相台总览-实时数据-概览数据-Total实时趋势变化-分天数据
export const queryDkxDataByDay = params => {
  return axios.get(`/dkxOverview/queryDkxDataByDay`, { params })
};
// 万相台总览-实时数据-概览数据-Total实时趋势变化-分时数据
export const queryDkxDatasByHour = params => {
  return axios.get(`/dkxOverview/queryDkxDatasByHour`, { params })
};
// 万相台总览-实时数据-概览数据-Total实时趋势变化-分时数据
export const downloadDkxHourAllIndexData = params => {
  return axios.get(`/dkxOverview/downloadDkxHourAllIndexData`, { params, responseType: "blob"  })
};
// 万相台总览-实时数据-表格明细
export const queryDkxDetailTableData = params => {
  return axios.get(`/dkxOverview/queryDkxDetailTableData`, { params })
};
// 万相台总览-实时数据-下载Total实时趋势变化-分时数据
export const downloadDkxDetailTableData = params => {
  return axios.get(`/dkxOverview/downloadDkxDetailTableData`, { params, responseType: "blob"  })
};
// 删除创意
export const delCreative = params => {
  return axios.post(`/creative/delCreative`, params)
};
// 获取近三天删除创意
export const queryDeletedCreative = params => {
  return axios.get(`/creative/queryDeletedCreative`, {params})
};
// 获取店铺下的计划&单元(公共)
export const queryShopCampaignAndGroup = params => {
  return axios.get(`/subwayBase/queryShopCampaignAndGroup`, {params})
};
// 查询引力魔方定向出价以及状态
export const queryCubeCrowdBid = params => {
  return axios.post(`/cubeCrowd/queryCubeCrowdBid`, params)
};
// 获取店铺下所有调价任务
export const queryJobByShop = params => {
  return axios.get(`/autoPrice/queryJobByShop`, {params})
};
// 获取店铺历史参考数据
export const queryHistoryReferenceReport = params => {
  return axios.get(`/autoPrice/queryHistoryReferenceReport`, {params})
};
// 获取自动调价计划列表
export const queryAutoPriceCampaignList = params => {
  return axios.get(`/autoPrice/queryCampaignList`, {params})
};
// 删除自动调价任务
export const removeJob = params => {
  return axios.get(`/autoPrice/removeJob`, {params})
};
// 修改任务状态
export const changeJobStatus = params => {
  return axios.post(`/autoPrice/changeJobStatus`, params)
};
// 创建引力魔方调价任务
export const addAutoPriceJob = params => {
  return axios.post(`/autoPrice/addAutoPriceJob`, params)
};
// 获取任务详情
export const getJobDetail = params => {
  return axios.get(`/autoPrice/getJobDetail`, {params})
};
// 获取店铺下所有调价日志
export const queryJobAutoPriceLog = params => {
  return axios.post(`/autoPrice/queryJobAutoPriceLog`, params)
};
// 获取店铺下所有规则模板
export const queryRuleModel = params => {
  return axios.get(`/autoPrice/queryRuleModel`, {params})
};
// 获取任务调价报告汇总
export const queryJobAutoPriceReportTotal = params => {
  return axios.post(`/autoPrice/queryJobAutoPriceReportTotal`, params)
};
// 获取任务调价报告分天
export const queryJobAutoPriceReportTotalByDay = params => {
  return axios.post(`/autoPrice/queryJobAutoPriceReportTotalByDay`, params)
};
// 获取授权店铺
export const queryShopManageList = params => {
  return axios.get(`/shop/queryShopManageList`, { params })
};
// 修改授权店铺
export const updShopManage = params => {
  return axios.post(`/shop/updShopManage`, params)
};




// WEBPACK FOOTER //
// ./src/api/tao.js